/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/KlondikeLogic/ChallengeAuthorities/PlayCardDailyKlondikeAuthority',[
        'SolitaireShared/KlondikeLogic/KlondikeAuthority',
        'SolitaireShared/KlondikeLogic/IDailyKlondikeAuthority',
        'SolitaireShared/CardLogic/IDailyAuthority',
        'SolitaireShared/CardLogic/IPlayCardDailyAuthority',
        'SolitaireShared/CardLogic/CardOp'
    ],
    function (KlondikeAuthority, IDailyKlondikeAuthority, IDailyAuthority, IPlayCardDailyAuthority, CardOp) {

    var PlayCardDailyKlondikeAuthority = function (param) {
        this.initPlayCardDailyKlondikeAuthority(param);
    };

    PlayCardDailyKlondikeAuthority.constructor = PlayCardDailyKlondikeAuthority;
    PlayCardDailyKlondikeAuthority.prototype = Object.create(IDailyKlondikeAuthority.prototype);
    IPlayCardDailyAuthority.call(PlayCardDailyKlondikeAuthority.prototype);

    Object.defineProperty(PlayCardDailyKlondikeAuthority.prototype, "NumberPlayed",  {
        get: function () {
            return this.CardPlayed() ? 1 : 0;
        }
    });

    PlayCardDailyKlondikeAuthority.KeyCardToPlay =  "CARDTOPLAY";

    /// <summary>
    /// Constructs a daily challenge authority which implements the win condition "Play card x to foundation"
    /// </summary>
    /// <param name="param">String value of card which must be played</param>
    PlayCardDailyKlondikeAuthority.prototype.initPlayCardDailyKlondikeAuthority = function (param) {
        IDailyKlondikeAuthority.call(this);

        if (param != null && param[PlayCardDailyKlondikeAuthority.KeyCardToPlay])
            this._cardToPlay = this.GetCardValue(param[PlayCardDailyKlondikeAuthority.KeyCardToPlay].toUpperCase());
        else throw "Invalid parameter passed in creating Daily Challenge";

        this.ChallengeType = IDailyAuthority.ChallengeType.PlayCard;
    };


    PlayCardDailyKlondikeAuthority.prototype.CardPlayed = function ()
    {
        for (var i = 0; i < 4; i++)
        {
            var pile = this.CardSupply.GetPile("Foundation" + i);
            if (!pile.Empty && pile.Top.ToString() == this._cardToPlay)
            {
                return true;
            }
        }

        return false;
    };

    PlayCardDailyKlondikeAuthority.prototype.IsGameWon = function ()
    {
        return this.GetIsGameWon();
    };

    PlayCardDailyKlondikeAuthority.prototype.GetIsGameWon = function ()
    {
        return this.CardPlayed();
    };

    PlayCardDailyKlondikeAuthority.prototype.GetHint = function (cycle, cheat)
    {

        if(cheat) {
            return IDailyKlondikeAuthority.prototype.GetHint.call(this,cycle,cheat);
        }

        cycle = !!cycle;
        var numTableaus = 7;

        var hints = [];
        var cards = ["CHALLENGE"];

        for (var i = numTableaus - 1; i >= 0; i--)
        {
            var pile = this.CardSupply.GetPile("Tableau" + i);
            if (pile.Empty)
                continue;

            var pileCards = pile.GetCards();
            for (var j = 0; j < pileCards.length; j++)
            {
                var card = pileCards[j];
                if (card.ToString() == this._cardToPlay)
                {
                    cards.push(card.Sequence.toString());
                    break;
                }
            }
        }
        if (cards.length <= 1)
        {
            var pile = this.CardSupply.GetPile("Waste");

            if (!pile.Empty)
            {
                var c = pile.Top;
                if (c.ToString() == this._cardToPlay)
                {
                    cards.push(c.Sequence.toString());
                }
            }
        }

        if (cards.length > 1)
        {
            var hint = new CardOp(this.CardSupply);

            hint.Parse(cards, 0);
            hints.push(hint);
        }

        return hints.length > 0 ? hints[0] : new CardOp(this.CardSupply);
    };

    PlayCardDailyKlondikeAuthority.prototype.GetCardValue = function (card)
    {
            return card;
    };

        return PlayCardDailyKlondikeAuthority;
});


